import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=46306ee0&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=ts&"
export * from "./AboutUs.vue?vue&type=script&lang=ts&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=46306ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46306ee0",
  null
  
)

export default component.exports